/* eslint-disable no-case-declarations */

import axios from 'axios';
import _debounce from 'lodash/debounce';
import postMediaCreate from '../../components/upload/example/post_medias_create';
import postMediaCreateWidthMinimum from '../../components/upload/example/post_medias_create_width-minimum';
import postMediaCreateHeightMinimum from '../../components/upload/example/post_medias_create_height-minimum';
import postMediaCrop from '../../components/upload/example/post_medias_crop';
import postMediaImage from '../../components/upload/example/post_medias_image';
import postMediaVideo from '../../components/upload/example/post_medias_video';
import deleteMediaSuccessfully from '../../components/upload/example/delete_medias_id_successfully';
import deleteMediaUnsuccessfully from '../../components/upload/example/delete_medias_id_unsuccessfully';
import getUsers from '../../components/header-component/example/get_users';
import getUserFromSSO from '../../components/header-component/example/get_user';

export default class Centios {
	constructor() {
		this.debouncedSubmit = [];
	}

	createDebounce(url) {
		this.debouncedSubmit[url] = _debounce(Centios.submit, 100, { leading: true });
	}

	checkIfDebounceExist(url) {
		if (this.debouncedSubmit[url] === undefined) {
			this.createDebounce(url);
		}
	}

	static getRequestUrl(api, endpoint) {
		let requestUrl = '';

		switch (api) {
			case 'blog':
				requestUrl = process.env.VUE_APP_BLOG_API;
				break;

			case 'core':
				requestUrl = process.env.VUE_APP_CORE_API;
				break;

			case 'sso':
				requestUrl = process.env.VUE_APP_SSO_API;
				break;

			default:
				requestUrl = '';
		}

		if ((endpoint !== undefined) && (endpoint !== '')) {
			requestUrl += endpoint;
		}

		return requestUrl;
	}

	core(type, endpoint, data) {
		const lowerCaseType = type.toLowerCase();
		const url = Centios.getRequestUrl('core', endpoint);
		return this[lowerCaseType](url, data);
	}

	blog(type, endpoint, data) {
		const lowerCaseType = type.toLowerCase();
		const url = Centios.getRequestUrl('blog', endpoint);
		return this[lowerCaseType](url, data);
	}

	sso(type, endpoint, data) {
		const lowerCaseType = type.toLowerCase();
		const url = Centios.getRequestUrl('sso', endpoint);
		return this[lowerCaseType](url, data);
	}

	get(url, data, withCredentials = true) {
		this.checkIfDebounceExist(url);
		return this.debouncedSubmit[url]('get', url, data, withCredentials);
	}

	post(url, data, withCredentials = true) {
		this.checkIfDebounceExist(url);
		return this.debouncedSubmit[url]('post', url, data, withCredentials);
	}

	put(url, data, withCredentials = true) {
		this.checkIfDebounceExist(url);
		return this.debouncedSubmit[url]('put', url, data, withCredentials);
	}

	delete(url, data, withCredentials = true) {
		this.checkIfDebounceExist(url);
		return this.debouncedSubmit[url]('delete', url, data, withCredentials);
	}

	static submit(type, url, data = {}, withCredentials = true) {
		// Stub
		const allowStub = true;
		const durationStub = 200;

		// Upload modifiers
		const widthMinimum = Math.random() > 0.75;
		const heightMinimum = Math.random() > 0.75;
		const cantDelete = Math.random() > 0.50;

		if (process.env.VUE_APP_STUB_API === 'true' && allowStub) {
			// Determine the API
			let api = null;
			if (url.includes(process.env.VUE_APP_BLOG_API)) {
				api = 'blog';
			} else if (url.includes(process.env.VUE_APP_CORE_API)) {
				api = 'core';
			} else {
				api = 'sso';
			}

			const path = url.split('.local/')[1];
			let call = `${api}_${type}_${path}`;
			call = call.replace(/\//g, '_');

			// If the call have argument, we want to remove them in order
			// to be able to determine which call we need to stub
			if (call.includes('?')) {
				call = call.split('?')[0];
			}

			// We want to remove the specific UUID given with the call
			// so that get_users_1111-2222-3333-4444 becomes get_users
			if (call.includes('get_api_v1_users') || call.includes('blog_delete_medias')) {
				call = call.substring(0, call.lastIndexOf('_')).substring(0, call.length - 1);
			}

			return new Promise((resolve) => {
				setTimeout(() => {
					switch (call) {
						// Stubbed GET /users from Core
						case 'core_get_api_users':
							// We add a little delay in order to see the skeletons
							setTimeout(() => {
								resolve(getUsers);
							}, 2000);
							break;

						// Stubbed GET /api/v1/users/[uuid] from SSO
						case 'sso_get_api_v1_users':
							resolve(getUserFromSSO[Math.floor(Math.random() * Math.floor(3))]);
							break;

						// Stubbed POST /medias/create on Blogue API
						case 'blog_post_medias_create':
							if (heightMinimum) {
								resolve(postMediaCreateHeightMinimum);
							}

							if (widthMinimum) {
								resolve(postMediaCreateWidthMinimum);
							}

							resolve(postMediaCreate);
							break;

						// Stubbed POST /medias/crop on Blogue API
						case 'blog_post_medias_crop':
							resolve(postMediaCrop);
							break;

						// Stubbed POST /medias on Blogue API
						case 'blog_post_medias':
							const response = data.get('upload-method') === 'url' ? postMediaVideo : postMediaImage;
							response.data.media.id = Math.ceil(Math.random() * 100000);
							resolve(response);
							break;

						// Stubbed DELETE /medias on Blogue API
						case 'blog_delete_medias':
							resolve(cantDelete ? deleteMediaUnsuccessfully : deleteMediaSuccessfully);
							break;

						default:
							// do nothing - will pass through the stub
							break;
					}
				}, durationStub);
			});
		}

		const payload = data;

		// Send credentials with the request
		axios.defaults.withCredentials = true;

		if (!withCredentials) {
			payload.withCredentials = false;
		}

		if (window.i18n && window.i18n.locale) {
			axios.defaults.headers['X-localization'] = window.i18n.locale;
		}

		return new Promise((resolve, reject) => {
			axios[type](url, payload)
				.then((response) => {
					if (response && response.data) {
						// We attach the http code to the data
						response.data.code = response.status;
					}

					resolve(response);
				})
				.catch((error) => {
					if (
						error
						&& error.response
						&& error.response.data
						&& error.response.data.code
					) {
						resolve(error.response);
					}

					reject(error);
				});
		});
	}

	static isInvalid(data) {
		const invalidCodes = [404, 403, 422, 401];
		return data.code && invalidCodes.includes(data.code);
	}

	static isValid(data) {
		return data.code && data.code === 200;
	}
}
